export const APP_ID = import.meta.env.VITE_MONGO_APP_ID;
export const BASE_API_URL = import.meta.env.VITE_API_URL;

export const endpointsUrl = `https://us-east-1.aws.data.mongodb-api.com/app/${APP_ID}/endpoint`;
